<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit()">
    <v-card :loading="loading">
      <v-card-text>
        <v-row class="mt-5">
          <v-col cols="6" offset="3">
            <alert-message />
          </v-col>
        </v-row>

        
        <v-row class="mt-5">
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <h3>Billing Information</h3>
            <hr />
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="form.firstName"
                  label="First Name"
                  v-if="editMode"
                />
                <div v-else>
                  <small>First Name</small>
                  <p>{{ form.firstName }}</p>
                </div>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.lastName"
                  label="Last Name"
                  v-if="editMode"
                />
                <div v-else>
                  <small>Last Name</small>
                  <p>{{ form.lastName }}</p>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="form.cardType"
                  disabled
                  label="Card Type"
                />
              </v-col>
              <v-col cols="5">
                <v-text-field
                  prefix="****-****-****-"
                  v-model="form.lastFour"
                  v-mask="`####`"
                  disabled
                  placeholder="xxxx"
                  label="Credit Card Number"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="form.expirationMonth"
                  label="Exp Month"
                  disabled
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="form.expirationYear"
                  label="Exp Year"
                  disabled
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <div v-show="editCard" id="dropin-container"></div>
            <v-btn
              class="mr-3"
              x-small
              v-show="editMode"
              @click="editCard = !editCard"
              >{{ !editCard ? `Edit Card` : `Cancel Edit Card` }}</v-btn
            >
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <h3>Billing Address</h3>
            <hr />
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col cols="12" offset-lg="3" sm="12" md="12" lg="6">
            <v-text-field
              v-model="form.billingAddress"
              label="Address"
              v-if="editMode"
            />
            <div v-else>
              <small>Address</small>
              <p>{{ form.billingAddress }}</p>
            </div>
          </v-col>
          <v-col cols="12" offset-lg="3" sm="12" md="12" lg="6">
            <v-text-field
              v-model="form.billingAddress2"
              v-if="editMode"
              :hide-details="true"
            />
            <div v-else>
              <p>{{ form.billingAddress2 }}</p>
            </div>
          </v-col>

          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <v-text-field
              v-model="form.billingCity"
              label="City"
              v-if="editMode"
            />
            <div v-else>
              <small>City</small>
              <p>{{ form.billingCity }}</p>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <state-select
              v-model="form.billingState"
              label="State"
              v-if="editMode"
            />
            <div v-else>
              <small>State</small>
              <p><StateView :value="form.billingState" /></p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col offset-lg="3" sm="12" md="12" lg="6">
            <v-text-field
              v-model="form.billingZipcode"
              label="Zip Code"
              v-if="editMode"
            />
            <div v-else>
              <small>Zipcode</small>
              <p>{{ form.billingZipcode }}</p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!editMode" @click="editMode = true" color="info"
          >Edit</v-btn
        >
        <v-btn v-else @click="editMode = false">Cancel</v-btn>

        <v-btn
          v-show="editMode"
          color="info"
          type="submit"
          :disabled="$v.$invalid"
          :loading="loading"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "src/mixins/formatterMixin";
import StateSelect from "components/StateSelect";
import { mapState, mapActions } from "vuex";
import dropin from "braintree-web-drop-in";
import AlertMessage from "src/components/AlertMessage";
import StateView from "components/StateView";

export default {
  components: {
    StateSelect,
    AlertMessage,
    StateView,
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      firstName: { required },
      lastName: { required },
    },
  },
  validationMessages: {
    form: {
      firstName: {
        required: "Required",
      },
      lastName: {
        required: "Required",
      },
    },
  },
  computed: {
    ...mapState({
      company: (state) => state.company.single,
      status: (state) => state.company.status,
    }),
  },
  data() {
    return {
      loading: false,
      valid: false,
      instance: null,
      editMode: false,
      editCard: false,
      billingHistoryModal: false,
      form: {
        firstName: "",
        lastName: "",
        lastFour: "1111",
        expirationMonth: "02",
        expirationYear: "2022",
        cardType: "Visa",
        billingAddress: "",
        billingState: "",
        billingCity: "",
        billingZipcode: "",
      },
    };
  },
  watch: {
    company(n) {
      if (n) {
        this.form = {
          ...n,
        };
      }
    },
    editMode(n) {
      if (!n) {
        this.editCard = false;
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.companyGetAccount();
    this.setupDropin();
  },

  beforeDestroy() {
    this.$store.dispatch("alert/clear");
  },

  methods: {
    ...mapActions({
      companyGetAccount: "company/getAccount",
      companyUpdate: "company/update",
      companyUpdatePayment: "company/updatePayment",
    }),

    setupDropin() {
      dropin.create(
        {
          authorization: process.env.VUE_APP_BRAINTREE_CLIENT_ID,
          vaultManager: true,
          customerIds: this.company.braintreeCustomerId,
          container: "#dropin-container",
          dataCollector: {
            kount: true, // Required if Kount fraud data collection is enabled
          },
        },
        (createErr, instance) => {
          if (createErr) {
            // Handle any errors that might've occurred when creating Drop-in
            console.error("error createErr", createErr);
            return;
          }
          this.instance = instance;
        }
      );
    },

    async getNonce() {
      await this.instance.requestPaymentMethod(
        async (requestPaymentMethodErr, payload) => {
          if (requestPaymentMethodErr) {
            this.loading = false;
            return false;
          }

          console.log("NONCE RESPONSE: ", payload);
          alert(`NONCE: ${payload.nonce}`);
          this.loading = false;
          this.instance.clearSelectedPaymentMethod();
        }
      );
    },

   async submit() {
      this.loading = true;

      if (this.editCard) {
        await this.instance.requestPaymentMethod(
          async (requestPaymentMethodErr, payload) => {
            if (requestPaymentMethodErr) {
              this.loading = false;
              this.instance.clearSelectedPaymentMethod();
              return false;
            }
            await this.companyUpdate({
              ...this.form,
            });
            await this.companyUpdatePayment({
              paymentNonce: payload.nonce,
            });
            if (!this.status.error) {
              this.$store.dispatch(
                "snackbar/success",
                "Billing information successfully updated"
              );
              this.instance.clearSelectedPaymentMethod();
            }
            this.loading = false;
            this.editMode = false;
            this.editCard = false;
          }
        );
      } else {
        await this.companyUpdate({
          ...this.form,
        });
        if (!this.status.error) {
          this.$store.dispatch(
            "snackbar/success",
            "Billing information successfully updated"
          );
          this.editMode = false;
          this.editCard = false;
        }
        this.loading = false;
      }
    },
  },
};
</script>